import { Button } from '@chakra-ui/react'
import { PageAlert } from 'BrokerTsLib/src/components'
import { useFlexGroup } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useParams } from 'react-router'

import { FlexGroupDetail, FlexGroupHeader } from '@/containers/flex-group'
import { SidebarProvider } from '@/context/SidebarContext'
import { Refresh } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

export const FlexGroupDetailPage = () => {
  const { flexGroupId: flexGroupIdParam } = useParams()
  const flexGroupId = parseInt(flexGroupIdParam ?? '')

  const { flexGroup, isError, isLoading, refetch } = useFlexGroup(flexGroupId)

  return isError ? (
    <PageAlert status="error" title="Chyba při načítání stránky">
      <Button colorScheme="red" isLoading={isLoading} onClick={() => refetch()}>
        <Refresh /> Obnovit stránku
      </Button>
    </PageAlert>
  ) : (
    <SidebarProvider>
      <PageWrapper
        header={<>
          <Breadcrumbs items={[
            { to: '/flex-group/list', label: 'Seznam flexibilních skupin' },
            {
              to: `/flex-group/${flexGroupId}`,
              label: flexGroup?.name ?? 'Flexibilní skupina',
              current: true,
            }
          ]} />
          <FlexGroupHeader
            flexGroup={flexGroup}
            isLoading={isLoading}
          />
        </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
            alignContent: 'baseline',
          },
        }}
      >
        <FlexGroupDetail flexGroupId={flexGroupId} />
      </PageWrapper>
    </SidebarProvider>
  )
}
